import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { ReactionsTypeCountCollection } from './reactions-type-count.types';

export function reactionsTypeCountBackend(): Backend<ReactionsTypeCountCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: (authUid, reactionTypeCount) => {
      if (!reactionTypeCount.id) {
        throw new Error('Missing reaction id.');
      }

      // - If the hasUserReacted is set to false that means that
      // the user unreacted.
      // - If the hasUserReacted is set to true that means that
      // the user reacted.
      const endpoint = reactionTypeCount.hasUserReacted
        ? 'users/0.1/unreact'
        : 'users/0.1/react';

      return {
        endpoint,
        payload: {
          context_id: reactionTypeCount.contextId,
          context_type: reactionTypeCount.contextType,
          reaction_type: reactionTypeCount.reactionType,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
